import { Component, ElementRef, HostListener, inject, OnInit } from '@angular/core';
import { NavigationComponent } from './components/navigation/navigation.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [NavigationComponent],
})
export class HeaderComponent implements OnInit {
  private el = inject(ElementRef);
  smallNav: boolean;
  ngOnInit(): void {
    this.onResize();
  }
  @HostListener('window:resize', ['$event'])
  public onResize(): void {
    this.smallNav = this.el?.nativeElement?.offsetWidth < 1450;
  }
}
